import { render } from "./PayrollTaxLiabilityList.vue?vue&type=template&id=24c350c8"
import script from "./PayrollTaxLiabilityList.vue?vue&type=script&lang=js"
export * from "./PayrollTaxLiabilityList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__